import trimExtraSpacesStringUtil from '../trim-spaces'

export default function toSnakeCaseStringUtil (str) {
  if (typeof str !== 'string') {
    throw new Error('Input must be a string')
  }

  return trimExtraSpacesStringUtil(str)
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    // .replace(/[A-Z]/g, match => '_' + match.toLowerCase())
    .replace(/[\s-]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/_{2,}/g, '_')
    .toLowerCase()
}
